import { render, staticRenderFns } from "./CodeVariables.vue?vue&type=template&id=33c29cbf&scoped=true"
import script from "./CodeVariables.vue?vue&type=script&lang=js"
export * from "./CodeVariables.vue?vue&type=script&lang=js"
import style0 from "./CodeVariables.vue?vue&type=style&index=0&id=33c29cbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c29cbf",
  null
  
)

export default component.exports